import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Switch, Route, Link, useParams, useNavigate } from "react-router-dom";
import axios from 'axios';
import Skeleton from '@mui/material/Skeleton';
import LinearProgress from '@mui/material/LinearProgress';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';

const MySubscription = () => {
    window.scrollTo(0, 0);
    const navigate = useNavigate();
    const [state, setState] = useState({
        notfound: false,
        progress: true,
        loading: true,
        sub: null,
        history: null,
    });

    useEffect(() => {
        if (!localStorage.getItem('token')) {
            navigate("/auth/login?redirect=/my-account/my-subscription");
        }
        document.title = 'My Subscription - SamplePack';
        setState(prev => ({
            ...prev,
            progress: true,
        }));
        fetchData();
    }, []);

    const fetchData = () => {
        setState(prev => ({
            ...prev,
            loading: true,
        }));

        axios({
            method: 'get',
            url: 'https://api.samplezpack.com/subscribtion-info',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            },
        }).then(function (response) {
            if (response.data.status === 200) {
                setState(prev => ({
                    ...prev,
                    loading: false,
                    progress: false,
                    notfound: false,
                    sub: response.data.sub,
                    history: response.data.history
                }));
                window.scrollTo(0, 0);
            } else {
                setState(prev => ({
                    ...prev,
                    notfound: true,
                    progress: false,
                    loading: false,
                }));
            }
        })
    }

    const convertPricetoPlan = (price) => {
        switch (price) {
            case '29900':
                return 'Musician plan';
                break;
            case '59900':
                return 'Producer plan';
                break;
            case '99900':
                return 'Unlimited plan';
                break;
            case '299000':
                return 'Musician plan (Annually)';
                break;
            case '599000':
                return 'Producer plan (Annually)';
                break;
            case '999000':
                return 'Unlimited plan (Annually)';
                break;
            default:
                return 'Free plan';
        }
    }

    const converttoDecimal = (str) => {
        return str.substring(0, str.length - 2) + "." + str.substring(str.length - 2);
    }

    const [open, setOpen] = useState(false);
    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    const [disabledBtn, setDisabledBtn] = useState(false);

    const handleCancel = () => {
        setDisabledBtn(true);
        axios({
            method: 'post',
            url: 'https://api.samplezpack.com/subscribtion/cencel',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            },
        }).then(function (response) {
            console.log(response);
            if (response.data.status === 200) {
                localStorage.setItem('iscancel', 'true');
                toast.success(response.data.msg);
                document.getElementById('sub-info').remove();
                setDisabledBtn(false);
            } else {
                toast.error(response.data.msg);
                setDisabledBtn(false);
            }
        })
    }


    return (
        <>
            {state.progress ?
                <div className='fixed top-0 left-0 right-0' style={{ top: '0px', zIndex: '100' }}>
                    <LinearProgress color='secondary' />
                </div> : ''
            }
            <div className="bg-sp-dark" style={{ backdropFilter: 'blur(10px)', background: 'linear-gradient(359deg, rgb(225 34 252 / 30%), transparent)' }}>
                <div className='py-10'>
                    <h1 className='text-4xl font-black text-white flex justify-center items-center gap-4 capitalize'>
                        <Link to='/my-account'>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
                            </svg>
                        </Link>
                        My Subscription
                    </h1>
                </div>
            </div>
            <div className="w-full md:max-w-4xl mx-auto my-16 px-4 md:px-0">
                {state.notfound ? (
                    <div className='flex justify-center items-center my-11 mx-4' style={{ height: '67vh' }}>
                        <div className='py-8'>
                            <h1 className='text-4xl font-black text-white flex justify-center capitalize text-center'>
                                No subscription found.
                            </h1>
                            <div className="text-center pt-2">Look like you did not Subscribe yet.</div>
                            <div className="text-center pt-4">
                                <Link to='/my-account' className='text-white bg-sp-pink focus:ring-0 focus:outline-none font-medium rounded-lg text-sm px-10 py-2.5 inline-flex justify-center  text-center'>My Account</Link>
                            </div>
                        </div>
                    </div>
                ) :
                    <div className=''>
                        {state.loading ? (
                            <>
                                {Array(10)
                                    .fill(1)
                                    .map((card, index) => (
                                        <div key={index}>
                                            <Skeleton className='relative p-2 mb-4 bg-white rounded-lg' variant="rectangular" width="100%" sx={{ bgcolor: 'grey.900' }}>
                                                <div className='w-full rounded-lg' />
                                            </Skeleton>
                                        </div>
                                    ))
                                }
                            </>
                        ) : (
                            <>
                                <div className='bg-sp-dark p-8 rounded-md'>
                                    <h3 className='text-2xl flex items-center mb-4'>
                                        {state.sub !== null ? convertPricetoPlan(state.sub.plan) : 'Free plan'}
                                        {state.sub !== null && <span className='text-sm px-4 py-1 ml-4 rounded-full bg-emerald-700'>{state.sub.status}</span>}
                                    </h3>
                                    <div className='w-full flex justify-between'>
                                        {state.sub !== null &&
                                            <div>
                                                {!localStorage.getItem('iscancel') ? 
                                                    <p id="sub-info">Your next payment is {state.sub.next} ({converttoDecimal(state.sub.plan)} baht)<br />
                                                        Your payment will be automatically renewed each month.</p>
                                                : <p>Upgrade your subscription to get access ton of samples.<br/>You can upgrade, downgrade, or cancel your subscription anytime.</p>}
                                            </div>
                                        }
                                        <div>
                                            {state.sub !== null && !localStorage.getItem('iscancel') &&
                                                <button className="text-white  border border-white focus:ring-0 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center mr-2" onClick={handleClickOpen}> Cancel renewal </button>
                                            }

                                            <Link to="/pricing" className="text-white  border-2 border-sp-pink bg-sp-pink hover:border-sp-purple focus:ring-0 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:bg-sp-pink dark:hover:bg-sp-purple dark:focus:ring-blue-800"> Upgrade your plan </Link>
                                        </div>
                                    </div>
                                </div>
                                {state.history !== null &&
                                    <div className='bg-sp-dark p-4 rounded-md mt-6'>
                                        <h4 className='text-xl pl-4 mb-6 mt-2'>Payment History</h4>
                                        <table className='w-full'>
                                            <thead>
                                                <tr>
                                                    <th className='px-4 py-2 text-left font-black'>Date</th>
                                                    <th className='px-4 py-2 text-right font-black'>Amount</th>
                                                </tr>
                                            </thead>
                                            <tbody className='sp-table-body'>
                                                {Object.entries(state.history).map(([k, item]) => (
                                                    <tr className='sp-table-tr' key={k}>
                                                        <td className='px-4 py-2 text-left'>{item.date}</td>
                                                        <td className='px-4 py-2 text-right'>{converttoDecimal(item.amount)}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                }

                            </>
                        )}
                    </div>
                }
            </div>

            <Dialog
                maxWidth="xs"
                open={open}
                onClose={handleClose}
                aria-describedby="alert-dialog-description"
            >
                <DialogContent style={{ padding: '0' }} id="alert-dialog-description">
                    <div className='mb-2 p-4' style={{ background: 'linear-gradient(90deg, #410a52, #1f0631, #26094b)' }}>
                        <h4 className='text-xl pt-5 text-white text-center'>Are you sure ?</h4>
                        <p className='text-white text-center p-5'>If click continue your download limit will be reset to 5 Download packs / month.</p>
                    </div>
                    <div className="p-5">
                        <button onClick={handleCancel} className="relative text-white text-center font-bold mt-0 block w-full whitespace-nowrap rounded-md border border-transparent bg-sp-pink px-4 py-2 text-base shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-0 focus:ring-offset-0" id="headlessui-popover-button-:rc:" type="button" aria-expanded="false" disabled={disabledBtn}><span>Continue</span> {disabledBtn && (
                            <div role="status" className='absolute inset-y-0 right-0 flex items-center pr-1'>
                                <svg className="inline mr-2 w-7 h-7 text-gray-200 animate-spin dark:text-gray-300 fill-white dark:fill-white" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                                </svg>
                                <span className="sr-only">Loading...</span>
                            </div>
                        )}</button>

                        <button onClick={handleClose} className="text-white mt-4 block w-full whitespace-nowrap rounded-md border border-white px-4 py-2 text-base font-medium shadow-sm  focus:outline-none focus:ring-0 focus:ring-offset-0" id="headlessui-popover-button-:rc:" type="button" aria-expanded="false"><span>Not now</span></button>
                    </div>
                </DialogContent>
            </Dialog>

            <ToastContainer
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={true}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="dark"
            />
        </>
    )
}

export default MySubscription;